import React from "react";
import { WHATSAPP_NUMBER } from "../lib/api";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  const msg = encodeURIComponent(
    "Hi Loan Junction, I'd like to know more about your loan services."
  );
  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-40 bg-[#25D366] hover:bg-[#1EBE5A] text-white rounded-full shadow-lg h-14 w-14 flex items-center justify-center lj-card-lift"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float"
    >
      <MessageCircle size={26} strokeWidth={2.2} />
    </a>
  );
}
